import React from "react";
import { List } from "../modules/ResultsReview";

export function ResultsReview() {
  return <List />;
}
